// extracted by mini-css-extract-plugin
export default {"Item":"SectionPanel_Item__dnZlG","Container":"SectionPanel_Container__eivLb"};